import { addYears, isBefore } from 'date-fns'
import { Dispatch, SetStateAction } from "react";

export type UploadFn = (
  file: File,
  onUploadProgress: (progressEvent: ProgressEvent) => void,
) => Promise<unknown>;

export const uploadImage = async ({
    file,
    docName,
    upload,
    setDocumentExistStatus,
    setFileType,
    setFileName,
    setUploadingStatus,
    setUploadingProgress,
    onFinish,
    onShowAlert,
  }: {
    file: File | null;
    docName: string;
    upload: UploadFn;
    onFinish?: () => void;
    setDocumentExistStatus?: Dispatch<SetStateAction<string>>;
    setFileType?: Dispatch<SetStateAction<string>>;
    setFileName?: Dispatch<SetStateAction<string>>;
    setUploadingStatus?: Dispatch<SetStateAction<string>>;
    setUploadingProgress?: Dispatch<SetStateAction<number>>;
    onShowAlert?: (title: string, description?: string) => void;
  }) => {
    setDocumentExistStatus?.("idle");
    const MAX_FILE_SIZE_IN_BYTES = 5 * 1024 * 1024; 

    if (!file) return; 
    
    if (file.size > MAX_FILE_SIZE_IN_BYTES) {
      onShowAlert?.("", `File size must be less than ${MAX_FILE_SIZE_IN_BYTES / (1024 * 1024)}MB.`);
      return;
    }
  
    const splitFileName = file?.name?.split(".");
    const docFileType = splitFileName[splitFileName?.length - 1];
    setFileType?.(docFileType);
    setFileName?.(`${docName}.${docFileType}`);
    setUploadingStatus?.("progress");

    try {
      await upload(file, (progressEvent) => {
        if (!progressEvent.total) return;
        const progress = (progressEvent.loaded / progressEvent.total) * 100;
        setUploadingProgress?.(Number(progress.toFixed(2)));
      });
      onFinish?.();
      setUploadingStatus?.("done");
    } catch (error) {
      setUploadingStatus?.("failed");
      const message = typeof error === "string"
        ? error
        : error?.response?.data?.message || error?.message;
      onShowAlert?.("", message || "Upload failed. Please try again.");
    }
  };
  

export const getCountryValue = (country) => {
  if (
    country === "NG" ||
    country === "SA" ||
    country === "KE" ||
    country === "ZM" ||
    country === "TZ" ||
    country === "UG"
  ) {
    return country;
  } else {
    return "INTERNATIONAL";
  }
};


export const validateDOB = (value) => {
    const today = new Date();
    const minDate = addYears(today, -18);

    return isBefore(new Date(value), minDate) || 'Age must be at least 18 years.';
  };